export default __webpack_public_path__ + "static/media/moodflix-logo.a129606d.png";